'use client';

import classnames from 'classnames';

import { useSanitizedHtml } from '../../utils/sanitize';
import { Dialog, DialogContent } from '../dialog';
import { Loading } from '../loading';
import type { ContentDialogProps } from './ContentDialog.types';
import { Header } from './layout/Header';

import styles from './ContentDialog.module.scss';

function ContentDialog({
  style,
  className,
  open,
  title,
  titleIcon,
  tooltip,
  warning,
  loading,
  ai,
  children,
  testId = 'ui-content-dialog',
  onClose,
}: ContentDialogProps) {
  const sanitized = useSanitizedHtml(
    typeof children === 'string' ? children : '',
  );

  return (
    <Dialog open={open}>
      <DialogContent
        style={style}
        ai={ai}
        className={classnames(styles['content'], className)}
        data-testid={testId}
      >
        <Header
          title={title}
          titleIcon={titleIcon}
          tooltip={tooltip}
          warning={warning}
          onClose={onClose}
        />
        <div className={styles['body']}>
          {loading ? (
            <div className={styles['loading']}>
              <Loading />
            </div>
          ) : typeof children === 'string' ? (
            <div dangerouslySetInnerHTML={sanitized} />
          ) : (
            children
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { ContentDialog };
